export class M3UbiAdicionales{
    public Atributo:string;
    public Valor:string;
}